export default __webpack_public_path__ + "static/media/igicon.fd51ed5a.svg";